export var PricingByType;
(function (PricingByType) {
    PricingByType["BY_RESOURCE"] = "BY_RESOURCE";
    PricingByType["BY_FLAT_RATE"] = "BY_FLAT_RATE";
})(PricingByType || (PricingByType = {}));
